// extracted by mini-css-extract-plugin
export var backBtn = "style-module--backBtn--15af7";
export var burgerContent = "style-module--burgerContent--ace53";
export var burgerMenu = "style-module--burgerMenu--13954";
export var content = "style-module--content--cbbab";
export var grid = "style-module--grid--b0502";
export var mddApplications = "style-module--mddApplications--68e0c";
export var megadd = "style-module--megadd--550d6";
export var wrapper = "style-module--wrapper--5a32c";